import { facadeApi } from 'api'

interface Params {
  tenantId: string
  fileId: string
}

export const downloadFileApi = ({ tenantId, fileId }: Params) =>
  facadeApi.get<Blob>(`file-manager/v1/tenants/${tenantId}/files/${fileId}/download`, {
    responseType: 'blob',
  })
